<div class="caixa-dialogo">
    <span class="titulo-dialogo">
        {{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_LOGIN.TITLE" | transloco }}
    </span>

    <div class="campo-rotulo-flutuante">
        <object class="icone-esquerdo" data="assets/agview-connect/circle_user.svg" type="image/svg+xml">
            {{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_LOGIN.LOGIN_LABEL" | transloco }}
        </object>
        <input type="text" inputmode="text" class="campo-texto"
            [class.invalido]="(senha.value !== '' && loginInvalido) || loginInvalido" placeholder="" #login
            (input)="loginInvalido = false" tabindex="1" (keydown.enter)="confirmar.click()" />
        <label>{{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_LOGIN.LOGIN_LABEL" | transloco }}</label>
    </div>

    <div class="campo-rotulo-flutuante">
        <object class="icone-esquerdo" data="assets/agview-connect/lock.svg" type="image/svg+xml">
            {{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_LOGIN.PASSWORD_LABEL" | transloco }}
        </object>
        <input [type]="mostrarSenha ? 'text' : 'password'" inputmode="text" class="campo-texto"
            [class.invalido]="(login.value !== '' && loginInvalido) || loginInvalido" placeholder="" #senha
            (input)="loginInvalido = false" tabindex="2" (keydown.enter)="confirmar.click()" />
        <label>{{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_LOGIN.PASSWORD_LABEL" | transloco }}</label>

        <div (click)="mostrarSenha = !mostrarSenha" class="icone-visibilidade">
            <object [hidden]="mostrarSenha" class="icone-direito" data="assets/agview-connect/eye.svg"
                type="image/svg+xml">
                {{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_LOGIN.SHOW_PASSWORD" | transloco }}
            </object>
            <object [hidden]="!mostrarSenha" class="icone-direito" data="assets/agview-connect/eye-slash.svg"
                type="image/svg+xml">
                {{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_LOGIN.HIDE_PASSWORD" | transloco }}
            </object>
        </div>
    </div>

    <div class="grupo-botoes">
        <button class="botao cancelar" (click)="fecharDialog()">
            {{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_LOGIN.CANCEL" | transloco }}
        </button>
        <button class="botao confirmar" (click)="validarCredenciais(login.value, senha.value)" tabindex="3" #confirmar>
            {{ "COMPONENTS.AGVIEW_CONNECT.DIALOG_LOGIN.ENTER" | transloco }}
        </button>
    </div>
</div>